import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetIdentification } from '../../../../state';

const AssetTagEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetIdentification({ assetTag: event.target.value }));
  };

  return (
    <TextField
      label="Asset Tag"
      size="small"
      required
      fullWidth
      value={currentAsset?.assetTag || ''}
      onChange={handleChange}
    />
  );
};

export default AssetTagEdit;
